import { http } from "../../utils/config";

/** Cộng / trừ điểm thủ công + lịch sử biến động. Hàm async thuần. */

export const addPointCustomer = (data) =>
  http.post("/api/point/add", data).then((res) => res.data);

export const deductPointCustomer = (data) =>
  http.post("/api/point/deduct", data).then((res) => res.data);

export const getPointHistory = (
  { currentPage = 1, pageSize = 10, fluctuation_type } = {},
  signal
) =>
  http
    .get("/api/point/history", {
      signal,
      params: {
        has_paginate: 1,
        size: pageSize,
        page: currentPage,
        ...(fluctuation_type ? { fluctuation_type } : {}),
      },
    })
    .then((res) => res.data);
